module.exports = __webpack_public_path__ + "img/jm.9d4a1bc6.svg";